var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-highlight-data" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "highlight-olap-data-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: {
            close: function ($event) {
              _vm.localActive = false
            },
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-highlight-data-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.localActive = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-highlight-data-title" }, [
            _vm._v("Подсветка данных OLAP-отчета"),
          ]),
          _c("c-switcher", {
            staticClass: "m-highlight-data-switcher",
            attrs: {
              type: "group",
              items: [
                { label: "Строки", value: "lines" },
                { label: "Столбцы", value: "columns" },
              ],
            },
            model: {
              value: _vm.switcherLocal,
              callback: function ($$v) {
                _vm.switcherLocal = $$v
              },
              expression: "switcherLocal",
            },
          }),
          _c("div", { staticClass: "m-highlight-data-params" }, [
            _c(
              "div",
              { staticClass: "m-highlight-data-params-lines" },
              [
                _c(
                  "div",
                  { staticClass: "m-highlight-data-params-lines-title" },
                  [_vm._v("Параметры строк")]
                ),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-lines-checkbox",
                  attrs: { type: "checkbox", label: "Филиал" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-lines-checkbox",
                  attrs: { type: "checkbox", label: "Должность" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-lines-checkbox",
                  attrs: { type: "checkbox", label: "Дата (год)" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-lines-checkbox",
                  attrs: { type: "checkbox", label: "Дата (месяц)" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "m-highlight-data-params-columns" },
              [
                _c(
                  "div",
                  { staticClass: "m-highlight-data-params-columns-title" },
                  [_vm._v("Параметры столбцов")]
                ),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-columns-checkbox",
                  attrs: { type: "checkbox", label: "Выручка повар южная" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-columns-checkbox",
                  attrs: { type: "checkbox", label: "Выручка суши" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-columns-checkbox",
                  attrs: { type: "checkbox", label: "Выручка филиала" },
                }),
                _c("c-switcher", {
                  staticClass: "m-highlight-data-params-columns-checkbox",
                  attrs: { type: "checkbox", label: "Сумма к выплате" },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "m-highlight-data-fill" }, [
            _c("div", { staticClass: "m-highlight-data-fill-title" }, [
              _vm._v("Цветовая шкала"),
            ]),
            _c("div", { staticClass: "m-highlight-data-fill-switchers" }, [
              _c(
                "div",
                { staticClass: "m-highlight-data-fill-switchers-col" },
                [
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "1",
                      type: "radio-colours",
                      colours: [
                        "#A969AF",
                        "#BE83B9",
                        "#D49EC2",
                        "#E7B5CA",
                        "#FFD4D4",
                      ],
                      label: "Один",
                    },
                  }),
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "2",
                      colours: [
                        "#29C4AA",
                        "#4BD5BC",
                        "#8EE2B5",
                        "#C7EEA9",
                        "#EFF5A8",
                      ],
                      type: "radio-colours",
                      label: "Два",
                    },
                  }),
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "3",
                      colours: [
                        "#9E77EC",
                        "#B18CFB",
                        "#B8A2EB",
                        "#CAB6F8",
                        "#DFD8FF",
                      ],
                      type: "radio-colours",
                      label: "Три",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "m-highlight-data-fill-switchers-col" },
                [
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "4",
                      colours: [
                        "#A65216",
                        "#BB7940",
                        "#D3A56F",
                        "#EACE9B",
                        "#FEF4C3",
                      ],
                      type: "radio-colours",
                      label: "Четыре",
                    },
                  }),
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "5",
                      colours: [
                        "#657CFF",
                        "#6DA0F8",
                        "#73C2EF",
                        "#78DCEA",
                        "#7DF9E1",
                      ],
                      type: "radio-colours",
                      label: "Пять",
                    },
                  }),
                  _c("c-switcher", {
                    staticClass: "m-highlight-data-fill-switchers-col-item",
                    attrs: {
                      name: "radio-group-button",
                      value: "6",
                      colours: [
                        "#DC427F",
                        "#E6678C",
                        "#EF8B97",
                        "#F6A8A1",
                        "#FDC8AA",
                      ],
                      type: "radio-colours",
                      label: "Шесть",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "m-highlight-data-buttons" },
            [
              _c("c-button", {
                staticClass: "m-highlight-data-buttons-cancel",
                attrs: { label: "Сбросить" },
                on: {
                  click: function ($event) {
                    _vm.localActive = false
                  },
                },
              }),
              _c("c-button", {
                staticClass: "m-highlight-data-buttons-apply",
                attrs: { label: "Применить", color: "primary" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }